module.exports = __webpack_public_path__ + "img/PCT00.fea6315b.svg";